import BaseModel from '@/core/components/input-widget/BaseModel';

export default class CollectionAppointmentModel extends BaseModel {
  uuid = null;
  name = null;
  text = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
